type EnvMap = Record<string, string | undefined>;

export interface SupabaseConfig {
  url: string;
  publishableKey: string;
}

export type SupabaseConfigResult =
  | { ok: true; config: SupabaseConfig }
  | { ok: false; missingKeys: string[]; message: string };

const readEnv = (env: EnvMap, key: string) => {
  const value = env[key];
  return typeof value === "string" && value.trim() !== "" ? value.trim() : undefined;
};

export const validateSupabaseConfig = (env: EnvMap): SupabaseConfigResult => {
  const url = readEnv(env, "VITE_SUPABASE_URL");
  const publishableKey = readEnv(env, "VITE_SUPABASE_PUBLISHABLE_KEY") ?? readEnv(env, "VITE_SUPABASE_ANON_KEY");
  const missingKeys: string[] = [];

  if (!url) {
    missingKeys.push("VITE_SUPABASE_URL");
  }

  if (!publishableKey) {
    missingKeys.push("VITE_SUPABASE_PUBLISHABLE_KEY");
  }

  if (missingKeys.length > 0) {
    return {
      ok: false,
      missingKeys,
      message: `Missing Supabase environment variable${missingKeys.length > 1 ? "s" : ""}: ${missingKeys.join(", ")}`,
    };
  }

  return { ok: true, config: { url, publishableKey } };
};

export const resolveSupabaseConfig = (env: EnvMap): SupabaseConfig => {
  const result = validateSupabaseConfig(env);
  if (!result.ok) {
    throw new Error(result.message);
  }

  return result.config;
};
